import { BeginnerModeLevel } from '@colonist/game-beginner-mode';
import { UIGameBeginnerModeGoalsController } from '../UIGameBeginnerModeGoalsController.ts';
export class UIGameBeginnerModeHelpersController {
    updateHelpers(data) {
        var _this_uiGameManager, _this_goalsController;
        if (data == undefined) return;
        if ((_this_uiGameManager = this.uiGameManager) === null || _this_uiGameManager === void 0 ? void 0 : _this_uiGameManager.gameState.isGameOver) return;
        if (data.numberOfRemainingGoals >= 0) (_this_goalsController = this.goalsController) === null || _this_goalsController === void 0 ? void 0 : _this_goalsController.updateGoals(data.numberOfRemainingGoals);
    }
    onCanvasResized(data) {
        var _this_goalsController, _this_uiGameManager;
        if (this.currentLevel != BeginnerModeLevel.Level1) return;
        (_this_goalsController = this.goalsController) === null || _this_goalsController === void 0 ? void 0 : _this_goalsController.destroy();
        if ((_this_uiGameManager = this.uiGameManager) === null || _this_uiGameManager === void 0 ? void 0 : _this_uiGameManager.gameState.isGameOver) return;
        this.goalsController = new UIGameBeginnerModeGoalsController(this.uiGameManager, this.currentLevel);
        this.goalsController.updateGoals(data.numberOfRemainingGoals);
    }
    constructor(uiGameManager, level){
        if (level != BeginnerModeLevel.Level1) return;
        this.uiGameManager = uiGameManager;
        this.currentLevel = level;
        this.goalsController = new UIGameBeginnerModeGoalsController(uiGameManager, level);
    }
}
